export default {
    isLoading: false,
    isLoadingMore: false,
    isInitial: true,
    availableFilters: null,
    activeFilters: {},
    items: [],
    top: [],
    pagination: {},
    tag: {},
    apiError: null,
};
